import { faCookie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatMessage } from "i18n/CurrentLocale";
import * as CookieConsent from "vanilla-cookieconsent";


interface CookieConsentButtonProps {
    className?: string;
}

export default function CookieConsentButton({ className }: CookieConsentButtonProps) {
    const label = formatMessage({ id: 'COOKIE_CONSENT_BTN_SHOW_PREFERENCES' });

    return (
        <button
            type="button"
            className={className ?? 'btn-square'}
            onClick={() => CookieConsent.showPreferences()}
            title={label}
            aria-label={label}
            data-testid="btn-cookie-consent"
        >
            <FontAwesomeIcon icon={faCookie} size="1x" />
        </button>
    );
}
